'use strict';

module.exports = {
    FLIGHT_GATEWAY: 'FLIGHT_GATEWAY',
    MEDIASHUTTLE_STORAGE_SERVER: 'MEDIASHUTTLE_STORAGE_SERVER',
    MANAGER_AND_AGENTS_SAAS: 'MANAGER_AND_AGENTS_SAAS',
    MANAGER_AND_AGENTS_SAAS_AGENT: 'MANAGER_AND_AGENTS_SAAS_AGENT',
    JET: 'JET'
};